import React, { useEffect, useState } from 'react';
import './ChartsDashboard.css';
import { AxiosResponse } from 'axios';
import constants from '../../constants';
import { Col, Row } from 'react-bootstrap';
import { withTranslation, WithTranslation } from 'react-i18next';
// import { SensorsTable } from './SensorsTable';
// import { Blockchains } from './Blockchains';
import { KYCTier } from './KYCTier';
import { ComulativeSales } from './ComulativeSales';
import SensorsByArea from './SensorsByArea';
import SensorsByAreaAndType from './SensorsByAreaAndType';
import { SensorsTable } from './SensorsTable';
import { TotalSensors } from './TotalSensors';
import authAxios from '../../authorization/axios';
// import { TotalSensors } from './TotalSensors';

const Analitics = ({ t }: WithTranslation) => {
  const [productTypesCount, setProductTypesCount] = useState<{
    type1: {
      total: number
    },
    type2: {
      total: number
    },
    type3: {
      total: number
    },
    type4: {
      total: number
    },
  }>({
    type1: {
      total: 0
    },
    type2: {
      total: 0
    },
    type3: {
      total: 0
    },
    type4: {
      total: 0
    }
  });
  const [kyc, setKyc] = useState<{
    tier1: {
      count: number
    },
    tier2: {
      count: number
    },
    tier0: {
      count: number
    }
  }>({
    tier1: {
      count: 0
    },
    tier2: {
      count: 0
    },
    tier0: {
      count: 0
    }
  });
  const [cumulativeSales, setCumulativeSales] = useState<{
    date: string,
    totalUSD: number,
    totalEUR: number,
    total: number
  }[]>();
  const [purcheseInfo, setPurcheseInfo] = useState<{
    activatedLicenses: number;
    purchasedLicenses: number;
    purchasedSensors: number;
    shippedSensors: number;
    type: number;
  }[]>([]);
  const [sensorCountByContry, setSensorCountByContry] = useState();

  const [productsCounter, setProductsCounter] = useState<any>();

  useEffect(() => {
    authAxios.get(constants.api.getProductTypesCount).then((res: AxiosResponse) => {
      if (res.data.success) {
        setProductTypesCount(res.data.data);
      }
    });

    authAxios.get(constants.api.getSensorCountByContry).then((res: AxiosResponse) => {
      if (res.data.success) {
        setSensorCountByContry(res.data.data);
      }
    });

    authAxios.get(constants.api.getPurcheseInfo).then((res: AxiosResponse) => {
      if (res.data.success) {
        setPurcheseInfo(res.data.data);
      }
    });

    authAxios.get(constants.api.getAggregateSales).then((res: AxiosResponse) => {
      if (res.data.success) {
        setCumulativeSales(res.data.data);
      }
    });

    authAxios.get(constants.api.getKycStatistic).then((res: AxiosResponse) => {
      if (res.data.success) {
        setKyc(res.data.data);
      }
    });
    authAxios.get(constants.api.getProductsCounter).then((res: AxiosResponse) => {
      if (res.data.success) {
        setProductsCounter(res.data.data);
      }
    });
  }, []);

  return <>
    <Row>
      <Col md='6'><KYCTier kyc={kyc} t={t}></KYCTier></Col>
      <Col md='6'>
        <SensorsTable
          purcheseInfo={purcheseInfo} t={t}></SensorsTable>
        <TotalSensors productTypesCount={productTypesCount} t={t}></TotalSensors>
      </Col>
    </Row>

    <Row>
      <Col md='6'>
        <ComulativeSales cumulativeSales={cumulativeSales} t={t}></ComulativeSales>
      </Col >
      <Col md='6'><SensorsByArea sensorCountByContry={sensorCountByContry} t={t}></SensorsByArea></Col>
    </Row>
    <Row>
      <Col md='6'><SensorsByAreaAndType productsCounter={productsCounter} t={t} productType={'licenses'}></SensorsByAreaAndType></Col>
      <Col md='6'><SensorsByAreaAndType productsCounter={productsCounter} t={t} productType={'sensors'}></SensorsByAreaAndType></Col>
    </Row>
    {/* <Row>
      <Col md='6'><Blockchains></Blockchains></Col>
    </Row> */}
  </>;
};

export default withTranslation()(Analitics);